export const getSafeNeuralChatPath = (value: string | null | undefined) => {
  if (!value || !value.startsWith("/neuralchat/")) return "/neuralchat";
  if (value.startsWith("//") || value.includes("\\")) return "/neuralchat";
  return value;
};

export const getInitials = (name: string) =>
  name
    .trim()
    .split(/\s+/)
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase() || "N";

export const formatNeuralTime = (value: string) => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return new Intl.DateTimeFormat("ko-KR", {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
};

export const roleLabel = (role: string) => {
  const labels: Record<string, string> = {
    CEO: "대표 · 개발",
    SALES_PM: "영업 · 마케팅 · PM",
    DEVELOPER: "개발",
    DESIGNER: "브랜딩 · 디자인",
    SUPPORT: "지원",
    SERVICE: "서비스",
  };
  return labels[role] || role;
};
